<template>
  <div class="previewImages column-me">
    <div class="img-div" v-for="(item,index) in showImages" :key="index">
      <div class="margin-bottom20" v-html="item.text" v-if="item.text&&item.text!==''"></div>
      <el-image :src="item.img" :preview-src-list="allImages" fit="scale-down" class="img-icon"
                hide-on-click-modal></el-image>
      <div class="row-me center-all margin-top10 margin-bottom10" v-if="index!==showImages.length-1">
        <img src="../assets/img/next.png" class="img-jian" draggable="false">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    images: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      showImages: this.images,
      allImages: [],
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.allImages = this.showImages.map(item => {
      return item.img
    })
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {},
}
</script>

<style lang="scss" scoped>
.previewImages {
  font-size: 18px;
  height: 100%;

  .img-div {
    height: auto;
    margin-bottom: 10px;
  }

  .img-icon {
    width: 100%;
    height: auto;
  }

  .img-jian {
    width: 50px;
    height: 50px;
    animation: bounce-down 1.5s linear infinite;
  }

  @keyframes bounce-down {
    0% {
      transform: translateY(-30px);
    }
    50% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(10px);
    }
  }
}
</style>
